var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('popper', {
    attrs: {
      "trigger": "clickToOpen",
      "force-show": _vm.forceShow
    }
  }, [_c('div', {
    staticClass: "popper"
  }, [_c('div', {
    staticClass: "warning-icon"
  }, [_vm._v("!")]), _vm._v(" "), _c('span', [_vm._t("text", function () {
    return [_vm._v("\n\t\t\t\tIn order to keep your data safe, we cannot allow for changes to your phone number at this\n\t\t\t\ttime. If you would like to change your phone number, please restart your application or\n\t\t\t\tcontact our\n\t\t\t\t"), _c('a', {
      attrs: {
        "target": "blank",
        "href": "mailto:hey@extra.app"
      }
    }, [_vm._v("Extra Concierge")]), _vm._v(".\n\t\t\t")];
  })], 2)]), _vm._v(" "), _vm._t("default", null, {
    "slot": "reference"
  })], 2);
};
var staticRenderFns = [];
export { render, staticRenderFns };